import { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useOnClickOutside } from 'src/hooks/useOnClickOutside'

const StudentRow = ({
  item,
  onEditClick = () => {},
  onDeleteClick = () => {},
}) => {
  const refMenu = useRef()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useOnClickOutside(refMenu, () => setIsMenuOpen(false))

  const handleMenuOpen = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const handleEditClick = () => {
    onEditClick()
    setIsMenuOpen(false)
  }

  const handleDeleteClick = () => {
    onDeleteClick()
    setIsMenuOpen(false)
  }

  return (
    <div className="details-table__row">
      <div className="details-table__col details-table__col-1">
        <div className="checkbox">
          <input type="checkbox" id={item.id} name={item.id} />
          <i className="checkbox-ico" />
        </div>
      </div>
      <div className="details-table__col details-table__col-2">
        <div className="details-table__main">
          <div className="details-table__user">
            <a href="#" className="details-table__ava">
              <img src="img/human-1-min.jpg" alt="" />
            </a>
            <Link className="details-table__name" to={`/children/${item.id}`}>
              {item.first_name} {item.last_name}
            </Link>
          </div>
          <span className="details-table__text">{item.username}</span>
        </div>
      </div>
      <div className="details-table__col details-table__col-3">
        {Math.round(item.practices_done)}/{Math.round(item.practices_count)}
      </div>
      <div className="details-table__col details-table__col-4">
        {Math.round(item.tests_done)}/{Math.round(item.tests_count)}
      </div>
      <div className="details-table__col details-table__col-5">
        {Math.round(item.tests_score)}%
      </div>
      <div className="details-table__col details-table__col-6">
        <span className="green-color">{Math.round(item.progress)}</span>
      </div>
      <div className="details-table__col details-table__col-7">
        <i className="hb-ico help-ico" />
      </div>
      <div className={`dropHb ${isMenuOpen ? 'active' : ''}`}>
        <div onClick={handleMenuOpen} className="dropHb-top">
          <i className="hb-ico dots-ico" />
        </div>
        <div ref={refMenu} className="dropHb-info">
          <ul>
            <li>
              <a href="#" onClick={handleEditClick}>
                <i className="hb-ico edit-ico" />
                Edit
              </a>
            </li>
            <li>
              <a href="#" onClick={handleDeleteClick}>
                <i className="hb-ico trash-ico" />
                Delete
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default StudentRow
